export const R = {
	"YourNextConsultation": "Your next consultation",
	"GoToUpcomingConsultation": "See the consultation",
	"BackToBookingButtonLabel": "Back to booking",
	"SundvaegtGoalCardTitle": "Your weight log",
	"SundvaegtGoalCardDescription": "For some, weighing themselves can be motivating. If it boosts your motivation, you can track your progress by logging your weight regularly.",
	"SundvaegtGoalCardActionButtonText": "Set yourself a goal",
	"SundvaegtGoalProgressStartLabel": "Start",
	"SundvaegtGoalProgressEndLabel": "Goal",
	"SundvaegtGoalProgressWeightLabel": "Weight",
	"SundvaegtSetWeightGoalModalTitle": "Set yourself a goal",
	"SundvaegtSetWeightGoalModalDescription": "By logging your weight regularly, you can track your progress. This can help you reach your goal.",
	"SundvaegtSetWeightGoalModalInputLabel": "Your desired target weight",
	"SundvaegtSetWeightGoalModalInputRequiredLabel": "You must enter your target weight.",
	"SundvaegtSetWeightGoalModalSubmitButton": "Save target weight",
	"SundvaegtSetWeightGoalModalInfoTitle": "Your target weight is too low",
	"SundvaegtSetWeightGoalModalInfoDescription": "Based on your height, we recommend a weight above {0} kg. This corresponds to a BMI of 18.5 or higher.",
	"SundvaegtSetWeightGoalModalValidationWeightGoalTooHigh": "Your target weight must be lower than your starting weight.",
	"SundvaegtSetWeightGoalModalValidationWeightGoalTooLow": "Please enter a target weight above {0} kg.",
	"SundvaegtSetWeightGoalErrorMessage": "Could not save weightgoal:",
	"SundvaegtAddWeightLogErrorMessage": "Could not save weight log:",
	"SundvaegtEditWeightLogErrorMessage": "Could not update weight log:",
	"SundvaegtDeleteWeightLogErrorMessage": "Could not delete weight log:",
	"SundvaegtSetWeightGoalInputPlaceholder": "Enter target weight",
	"SundvaegtProgramConfirmationLabel": "You are now on your way with your weight loss!",
	"SundvaegtProgramLogWeightButtonLabel": "Log weight",
	"SundvaegtAddWeightLogModalTitle": "Log weight",
	"SundvaegtAddWeightLogModalInputLabel": "Weight",
	"SundvaegtAddWeightLogModalInputRequiredLabel": "You must enter a weight.",
	"SundvaegtAddWeightLogModalSubmitButton": "Save weight",
	"SundvaegtAddWeightLogInputPlaceholder": "Enter weight",
	"SundvaegtWeightLogCardLatestWeightLossLabel": "Weight loss since last:",
	"SundvaegtWeightLogCardOverallWeightLossLabel": "Total weight loss:",
	"SundvaegtWeightLogCardOverallWeightLossStatus": "You have lost {0} out of {1}",
	"SundvaegtWeightLogCardOverallWeightLossStatusPart1": "You have lost",
	"SundvaegtWeightLogCardOverallWeightLossStatusPart2": "out of",
	"SundvaegtWeightEditWeightLogLabel": "Edit weight log",
	"SundvaegtWeightDeleteWeightLogLabel": "Delete weight log",
	"SundvaegtDateInputLabel": "Date",
	"SundvaegtDateInputRequiredLabel": "You must enter a date.",
	"SundvaegtPleaseEnterValidWeightLabel": "Please enter a valid weight.",
	"SundvaegtWeightLogChartYLabel": "Weight (kg)",
	"SundvaegtWeightLogChartXLabel": "Month",
	"SundVaegtChartTooltip": "Date: {0}, Weight: {1}",
	"NnSundvaegtConsultationsLeft": "You have {0} free video consultations",
	"NnSundvaegtConsultationsExpire": "Your free consultations expire:",
	"NnSundvaegtAreYouDone": "Have you reached your weight goal or have you quit Wegovy? Here you can ",
	"NnSundvaegtCancelProgram": "unsubscribe from SundVægt Sammen.",
	"SundvaegtFeedbackTitle": "Help us improve",
	"SundvaegtFeedbackDescription": "We would love to hear about your experience with SundVægt. Answer three short questions and help us understand what works well and where we can improve.",
	"SundvaegtFeedbackButtonLabel": "Answer questions",
	"EditGoalWeight": "Edit weight goal",
	"ArticlesHeader": "Selected articles",
	"ShowMore": "Show more",
	"ShowLess": "Show less",
	"All": "All",
	"MeetTheTeamHeader": "Meet the team",
	"ArticleNewLabel": "New"
}